export const CONTROLLER = {
  USER: '/users',
  PRICES: '/prices',
  ADRESSES: '/addresses',
  FISCAL_DATA: '/fiscal_data',
  ORDERS: '/orders',
  REPORTS: '/poll_answers',
};
